<template>
  <div>
    <!-- <div class="card card-custom card-stretch gutter-b">
      <div class="card-body pt-3 pb-0">
        <div class="alert alert-light" role="alert" style="font-family: Arial, sans-serif;font-size: 12px;">
          <p><strong>Envío de liquidaciones de comisiones: </strong>entre los días <strong>7</strong> y <strong>10</strong>.</p>
          <p><strong>Presentación de facturas o boletas: </strong> desde el día <strong>8</strong> hasta  <strong>13</strong>, dependiendo de los días hábiles del mes.</p>
          <p><strong>Pagos de las comisiones: </strong> se realizan inicialmente el día <strong>15</strong> de cada mes. Los documentos enviados después de esta fecha serán pagados los siguientes lunes del mes en curso.</p>
        </div>        
      </div>
    </div> -->

    <div class="card card-custom card-stretch gutter-b">
        <div class="card-body px-3">
            <v-row class="elevation-1 align-items-center">
                <v-col class="d-flex" cols="12" sm="2">
                    <v-select
                        label=""
                        v-model="anio"
                        hint="Año"
                        single-line
                        persistent-hint
                        clearable
                        :items = "getYears()"
                    ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="2">
                    <v-select
                        :items="getMonths()"
                        label=""
                        v-model="mes"
                        hint="Mes"
                        single-line
                        persistent-hint
                        clearable
                    ></v-select>
                </v-col>
                <button
                    type="button"
                    @click="searching()"
                    class="mr-auto btn btn-contempora-a btn-shadow btn-lg font-weight-bold mx-3 my-1"
                >
                    Filtrar
                </button>
                <button
                    type="button"
                    @click="descargaLiquidacion()"
                    class="btn btn-contempora-b btn-shadow btn-lg font-weight-bold mx-3 my-1"
                >
                    Descarga
                    <br>
                    Detalle Liquidacion
                </button>
                <button
                    type="button"
                    @click="descargaDetalle()"
                    class="btn btn-contempora-b btn-shadow btn-lg font-weight-bold mx-3 my-1"
                >
                    Descarga 
                    <br>
                    Detalle Comisión
                </button>
                <button
                    type="button"
                    @click="openModalCalendario()"
                    class="btn btn-contempora-c btn-shadow btn-lg font-weight-bold mx-3 my-1"
                >
                    Calendario de Pagos
                </button>
            </v-row>
        </div>
    </div>

    <DataTableLiquidacionCorredor
      :headers="headers"
      :items="datosVisiblesTabla"
      :page.sync="pagination.page"
      :itemKey="itemKey"
      :items-per-page="pagination.page_size"
      hide-default-footer
      :pagination="pagination"
      :pages="pages"
      v-on:fetch-more="fetchMore"
      :loading="loading"
    >
    </DataTableLiquidacionCorredor>

    <b-modal 
        id="modal-calendario" 
        title="Calendario de Pagos"
        :hide-footer="true"
        centered
    >
        <CalendarioPagos/>
    </b-modal>
  </div>
</template>

<script>
import { GET_ODATA_COMISIONES } from "@/core/services/store/odata.facturacionComision.module";
import DataTableLiquidacionCorredor from "@/view/content/widgets/advance-table/DataTableLiquidacionCorredor.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
DESCARGAR_DETALLE_COMISION,
DESCARGAR_DETALLE_LIQUIDACION
} from "@/core/services/store/liquidacion.module";
import {
  GET_ODATA_LIQUIDACIONES_CORREDOR,
} from "@/core/services/store/odata.liquidacion.module";


import XLSX from "xlsx";
import CalendarioPagos from "./CalendarioPagos.vue";
export default {
  name: "detalleFacturacionCorredor",
  components: {
    DataTableLiquidacionCorredor,
    CalendarioPagos
  },
  watch: {
    itemsPerPage: {
      handler() {
        ////console.log(("handler")
        this.pagination.page = 1;
        this.pagination.page_size = this.itemsPerPage;
        this.page = 1;
        this.searching();
      },
      deep: true,
    },
  },
  data() {
    return {
      anio: null,
      mes: null,
      rutCorredor: null,
      rutContratante: null,
      page: 1,
      itemsPerPage: 10,
      datosFacturacion: [],
      datosVisiblesTabla: [],
      pages: 1,
      paginationStart: { page: 1, page_size: 10, totalRecords: 0, filter: "" },
      pagination: {
        page: 1,
        page_size: this.itemsPerPage,
        totalRecords: 0,
        filter: "",
      },
      itemKey: "_Id",
      filterProject: "",
      filterStage: "",
      loading: false,
      dataFilterProjectItems: [],
      dataFilterStageItems: [],
      dataFilterPagesItems: [
        { text: "10", value: 10, default: true },
        { text: "20", value: 20 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
      ],
      headers: [
        {
          text: "Nombre Contratante",
          align: "left",
          sortable: false,
          value: "facturacionComisionId",
        },
        {
          text: "Nombre Contratante",
          value: "NombreContratante",
          width: 90,
          sortable: false,
        },
        { text: "RamoFecu", value: "RamoFecu" },
        { text: "Poliza", value: "Poliza" },
        { text: "PrimaNeta", value: "PrimaNeta" },
        // { text: "PORCENTAJE", value : "porcentaje" },
        // { text: 'PrimaNeta', value: '_id', sortable: false }
      ],
    };
  },
  created() {
    this.$bus.$on("resultadoSubidaCorredor", (resultado) => {
      this.initSearching(this.paginationStart);
    //   this.searching();
    });
    // console.log('created')
  },
  mounted() {
    //console.log("RUT USUARIO => " + JSON.stringify( this.$store.state.auth.user));
    this.rutCorredor = this.$store.state.auth.user.rutUsuario;
    // this.pagination.page_size = 10
    // this.$Progress.start();
    this.loading = false;
    // this.loadProjects();
    // this.initSearching(this.paginationStart);
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Reservas" }]);
    // console.log('mounted')
    this.searching()
  },
  methods: {
    log(msg){
        // console.log(msg)
    },
    getCurrentYear() {
        const date = new Date()
        return date.getFullYear()
    },
    getCurrentMonth() {
        const date = new Date()
        return date.getMonth() + 1
    },
    initSearching(
      query = { pages: 1, page_size: this.itemsPerPage, filter: "" }
    ) {
    //   query.filter = this.filterGrid();
    //   this.cargarComsiones(query);
      this.cargarComsiones({ page: 1, page_size: this.itemsPerPage, filter: "", rut: this.$store.state.auth.user.rutUsuario, year: this.getCurrentYear()});
    },
    searching() {
    //   this.pagination.filter = this.filterGrid();
      
    //   this.cargarComsiones(this.pagination);
        // this.cargarComsiones({ page: 1, page_size: this.itemsPerPage, filter: "", rut: this.$store.state.auth.user.rutUsuario, year: this.anio});

        // console.log('searching')
        const filter = { 
            page: this.page, 
            page_size: this.itemsPerPage,
            filter: "", 
            rut: this.rutCorredor,
            year: this.anio,
            month: this.mes,
            codigoRol: 'CORREDOR',
        }
        this.log(filter)
        this.cargarComsiones(filter)
    },
    descargaDetalle() {      
      this.descargarDetalleComision();
    },
      descargaLiquidacion() {      
      this.descargaDetalleLiquidacion();
    },
    filterGrid() {
      let filters = [];
      let filtros = "";
      if (this.rutCorredor && this.rutCorredor !== "") {
        filters.push("RutCorredor eq " + this.rutCorredor);
        // filters.push("contains(toupper(RutCorredor),toupper('" + this.rutCorredor + "'))");
      }
      if (this.mes && this.mes !== "") {
        filters.push("Mes eq " + this.mes);
        // filters.push("contains(toupper(RutCorredor),toupper('" + this.rutCorredor + "'))");
      }
      if (this.anio && this.anio !== "") {
        filters.push("Anio eq " + this.anio);
      }
      // if( this.filterStage && this.filterStage.codigoEtapa !== "" ) {
      //   filters.push("contains(toupper(Etapa),toupper('" + this.filterStage.descripcionEtapa + "'))");
      // }
      if (filters.length > 0) {
        filtros = "&$filter=" + filters.join(" AND ");
      }
      return filtros;
    },
    goToBookingsItem(item) {
      this.$router.push({
        name: "booking-view",
        params: { codigoReserva: item.codigoReserva },
      });
    },
    fetchMore(query) {
      ////console.log(("fetchMore Booking")
      this.pagination.page = query.page;
      this.pagination.page_size = query.page_size;
      this.page = query.page;
      //7//console.log((this.pagination)

      this.datosVisiblesTabla = this.paginate(query.page - 1)
    //   this.searching();
    },
    // cargarComsiones(
    //   query = { page: 1, page_size: this.itemsPerPage, filter: "" }
    // ) {
    cargarComsiones(query) {
      this.$store
        .dispatch(GET_ODATA_LIQUIDACIONES_CORREDOR, query)
        .then((response) => {
            this.log(response)
        //   this.pagination.totalRecords = response["@odata.count"];
          this.datosFacturacion = this.analizeTableData(response)
        
          this.pagination.totalRecords = this.datosFacturacion.length
          this.pagination.page = query.page;
          this.page = query.page;
          this.pagination.page_size = query.page_size;
          this.pages = Math.ceil(
            this.pagination.totalRecords / query.page_size
            // this.pagination.totalRecords / this.itemsPerPage
          );

          this.datosVisiblesTabla = this.paginate(0)

          this.loading = false;
          this.$Progress.finish();
        });
    },
    getPercent(item) {
      return Math.round(
        (item.TotalArchivosCargados / item.TotalArchivos) * 100
      );
    },
    getVariantType(item) {
      let porcentaje = this.getPercent(item);
      if (porcentaje == 100) {
        return "success";
      } else if (porcentaje >= 50) {
        return "warning";
      } else if (porcentaje > 30) {
        return "primary";
      }
      return "danger";
    },
    getYears()
    {
      const d = new Date();
      let year = d.getFullYear();
      let years = [year]
      years.push(2024)

      for(var i = 1 ; i < 5 ; i++)
      {
        if((year-i) > 2024 )
        years.push(year-i)
      }

       return years
    },
    getMonths()
    {

     return     [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      
    },
    onChangeFilterPagesItems(event) {
      this.pagination.page = 1;
      this.page = 1;
      this.itemsPerPage = event.value;
      this.pagination.page_size = event.value;
    },
    onChangeFilterProject(event) {
      this.loadStages({ codigoProyecto: event.codigoProyecto });
    },
    onexport() { 

     // let query = { page: 1, page_size: this.itemsPerPage, filter: "" };
      let monedaFormateada = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 3,
      });
      
      let query = { pages: 1, filter: "" }
      query.filter = this.filterGrid();  

      let  pagination2 = {
        page: 1,
        page_size: 100,
        totalRecords: 0,
        filter: "",
      }
      pagination2.filter = this.filterGrid();
      //this.cargarComsiones(this.pagination);

      this.$store
        .dispatch(GET_ODATA_COMISIONES,pagination2)
        .then((response) => {
          // response.value.forEach((element) => {
          //   element.ImpuestoAfecta = monedaFormateada
          //     .format(element.ImpuestoAfecta.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.ImpuestoExenta = monedaFormateada
          //     .format(element.ImpuestoExenta.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.ImpuestoTotal = monedaFormateada
          //     .format(element.ImpuestoTotal.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.MontoComisionAfecta = monedaFormateada
          //     .format(element.MontoComisionAfecta.toFixed(3))
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.MontoComisionExenta = monedaFormateada
          //     .format(element.MontoComisionExenta.toFixed(3))
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.MontoAfectaUF = element.MontoAfectaUF.toFixed(5)
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.MontoExentaUF = element.MontoExentaUF.toFixed(5)
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.Neto = monedaFormateada
          //     .format(element.Neto.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.TipoCambio = element.TipoCambio.toFixed(2)
          //     .replace("$", "")
          //     .replace(".", ",");
          //   element.TotalAfecta = monedaFormateada
          //     .format(element.TotalAfecta.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.TotalExenta = monedaFormateada
          //     .format(element.TotalExenta.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.AfectoNeto = monedaFormateada
          //     .format(element.AfectoNeto.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   element.ExentoNeto = monedaFormateada
          //     .format(element.ExentoNeto.toFixed(3))
          //     .replace("$", "")
          //     .replace(",", "")
          //     .replace(".", "");
          //   // element.TotalGirar = monedaFormateada
          //   //   .format(element.TotalGirar.toFixed(3))
          //   //   .replace("$", "")
          //   //   .replace(",", "")
          //   //   .replace(".", "");
          // });

          let datos = []
          response.value.forEach((element) => {
              let unDato =   { 
                Mes: element.Mes, 
                Anio: element.Anio, 
                RutCorredor: element.RutCorredor, 
                DvCorredor : element.RutCorredorDv, 
                NombreCorredor : element.NombreCorredor, 
                Sucursal :element.Sucursal, 
                RutContratante: element.RutContratante,
                NombreContratante : element.NombreContratante,
                Ramo: element.Ramo,
                Poliza : element.Poliza,
                Endoso : element.Endoso,
                Moneda : element.Moneda,
                Prima : element.PrimaNeta,
                PorcentajeComision : element.PorcentajeComision,
                TipoComision : element.TipoComision
                 };
              datos.push(unDato);
          });

          let Heading = [['Mes', 'Anio', 'Rut Corredor', 'Dv Corredor','NombreCorredor','Sucursal','Rut Contratante','Nombre Contratante', 'Ramo','Poliza','Endoso','Moneda','Prima','% Comision','Tipo Comision' ]];

          const archivo =
            "DetalleComisiones_" + new Date().toISOString().substr(0, 10);
          // var conciliaciones = [];
          // conciliaciones = XLSX.utils.json_to_sheet(response.value);    

          const ws = XLSX.utils.json_to_sheet([]);

          // if (this.conciliacionesFiltro.length > 0) {
          //   conciliaciones = XLSX.utils.json_to_sheet(this.conciliacionesFiltro);
          // } else {
          //   conciliaciones = XLSX.utils.json_to_sheet(this.conciliaciones);
          // }
          var libro = XLSX.utils.book_new();
           let  ws2 = XLSX.utils.json_to_sheet( datos, { origin: 'A2', skipHeader: true });
          XLSX.utils.sheet_add_aoa(ws2, Heading);
          XLSX.utils.sheet_add_json(libro, datos, { origin: 'A2', skipHeader: true })

          XLSX.utils.book_append_sheet(
            libro,
            ws2,
            "DetalleComisiones"
          );

          // XLSX.utils.book_append_sheet(
          //   libro,
          //   conciliaciones,
          //   "DetalleComiisones"
          // );
          XLSX.writeFile(libro, `${archivo}.xlsx`);
        })
        .catch((error) => {
          this.makeToast(
            false,
            "Ha currido un problema al descargar el documento",
            "Aviso",
            "danger"
          );
        });
    },
        makeToast(append = false, texto, titulo, variant) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 5000,
        variant: variant,
        toaster: "b-toaster-top-right",
        appendToast: append,
      });
    },
       descargaDetalleLiquidacion(item) {
     var rutCorredor = this.rutCorredor ;
     var mes = this.mes;
     var anio = this.anio;
     if(mes != '' && mes != null && anio != '' && anio != null )
     {      
      this.$store
        .dispatch(DESCARGAR_DETALLE_LIQUIDACION, {
          rutCorredor: rutCorredor,
          mes: mes,
          anio: anio,
          esDetalle: false

        })
        .then((resultado) => {
          if (resultado != null && resultado.length > 0) {
            let tipoDocumento = "";
            resultado.forEach((element) => {
              if (element == "AFECTA") {
                tipoDocumento = element;
              } else if (element == "EXENTA") {
                tipoDocumento = element;
              } else if (tipoDocumento != "") {
                const url = `data:application/vnd.ms-excel;base64,${element}`;
                const descargar = document.createElement("a");
               // const nombreDocumento = `${rutCorredor}.xls`;
                const nombreDocumento = `DetalleLiquidacion.xls`;

                tipoDocumento = "";
                descargar.href = url;
                descargar.download = nombreDocumento;
                descargar.click();
                this.makeToast(
                  false,
                  "Documento Descargado",
                  "Aviso",
                  "success"
                );
              }
            });
          } else {
            this.makeToast(
              false,
              "Ha currido un error o el documento no existe",
              "Aviso",
              "danger"
            );
          }
        })
        .catch((error) => {
          this.makeToast(
            false,
            "Ha currido un problema al descargar el documento",
            "Aviso",
            "danger"
          );
        });
        }
        else
        {
          this.makeToast(
            false,
            "Debe Seleccionar Año y Mes",
            "Aviso",
            "danger"
          );
        }      
    },
   descargarDetalleComision(item) {
     var rutCorredor = this.rutCorredor ;
     var mes = this.mes;
     var anio = this.anio;

    if(mes != '' && mes != null && anio != '' && anio != null )
    {
      this.$store
            .dispatch(DESCARGAR_DETALLE_COMISION, {
              rutCorredor: rutCorredor,
              mes: mes,
              anio: anio,
              esDetalle: true

            })
            .then((resultado) => {
              if (resultado != null && resultado.length > 0) {
                let tipoDocumento = "";
                resultado.forEach((element) => {
                  if (element == "AFECTA") {
                    tipoDocumento = element;
                  } else if (element == "EXENTA") {
                    tipoDocumento = element;
                  } else if (tipoDocumento != "") {
                    const url = `data:application/vnd.ms-excel;base64,${element}`;
                    const descargar = document.createElement("a");
                    //const nombreDocumento = `${rutCorredor}.xls`;
                    const nombreDocumento = `DetalleComision.xls`;

                    tipoDocumento = "";
                    descargar.href = url;
                    descargar.download = nombreDocumento;
                    descargar.click();
                    this.makeToast(
                      false,
                      "Documento Descargado",
                      "Aviso",
                      "success"
                    );
                  }
                });
              }
                else {
                this.makeToast(
                  false,
                  "Ha currido un error o el documento no existe",
                  "Aviso",
                  "danger"
                );
              }
            })
            .catch((error) => {
              //console.log("ERROR => " + JSON.stringify(error));
              this.makeToast(
                false,
                "Ha currido un problema al descargar el documento",
                "Aviso",
                "danger"
              );
            });
    }
    else
    {
      this.makeToast(
                false,
                "Debe Seleccionar Año y Mes",
                "Aviso",
                "danger"
              );
    }      
    },
    openModalCalendario(){
        this.$bvModal.show("modal-calendario")
    },
    analizeTableData(data){
        let newBoletas = []

        const boletas = data.filter((element) => element.TipoDocumento == 'BOLETA')
        const facturas = data.filter((element) => element.TipoDocumento == 'FACTURA')

        const months = [...new Set(boletas.map(item => item.Mes))]
        const years = [...new Set(boletas.map(item => item.Anio))]

        years.forEach(year => {
            months.forEach(month => {
                const foundMonth = boletas.filter((element) => (element.Mes == month && element.Anio == year))
                
                if(foundMonth.length > 1){
                    newBoletas.push({
                        ...foundMonth[0],
                        AfectoNeto: foundMonth[0].AfectoNeto + foundMonth[1].AfectoNeto,
                        ExentoNeto: foundMonth[0].ExentoNeto + foundMonth[1].ExentoNeto,
                        ImpuestoAfecta: foundMonth[0].ImpuestoAfecta + foundMonth[1].ImpuestoAfecta,
                        ImpuestoExenta: foundMonth[0].ImpuestoExenta + foundMonth[1].ImpuestoExenta,
                        ImpuestoTotal: foundMonth[0].ImpuestoTotal + foundMonth[1].ImpuestoTotal,
                        MontoAfectaUF: foundMonth[0].MontoAfectaUF + foundMonth[1].MontoAfectaUF,
                        MontoExentaUF: foundMonth[0].MontoExentaUF + foundMonth[1].MontoExentaUF,
                        tipoMovimiento: "AFECTA/EXENTA",
                        TotalAfecta: foundMonth[0].TotalAfecta + foundMonth[1].TotalAfecta,
                        TotalComision: Math.round(((foundMonth[0].MontoAfectaUF + foundMonth[1].MontoAfectaUF) + (foundMonth[0].MontoExentaUF + foundMonth[1].MontoExentaUF)) - (foundMonth[0].ImpuestoTotal + foundMonth[1].ImpuestoTotal)),
                        TotalExenta: foundMonth[0].TotalExenta + foundMonth[1].TotalExenta,
                    })
                } else {
                    newBoletas.push(foundMonth[0])
                }
            })
        })

        newBoletas = newBoletas.filter(function(element) {
            return element !== undefined;
        })

        // console.log('newBoletas: ', newBoletas)

        return newBoletas.concat(facturas)
    },
    paginate(page_number) {
        const page_size = this.itemsPerPage
        return this.datosFacturacion.slice(page_number * page_size, page_number * page_size + page_size)
    },
  },
};
</script>
<style >

.alert.alert-light {
    background-color: #fff !important;
    border-color: #F3F6F9;
    color: #80808F;
}

</style>